// src/components/common/Toast.jsx
import { useState, useEffect, useContext } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";

const Toast = ({ message, type, onClose }) => {
  const [visible, setVisible] = useState(true);
  const { t } = useContext(LocaleContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose();
    }, 4000); // auto-dismiss after 4000= 4s

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) return null;

  const typeHeader = {
    success: t("success"),
    danger: t("error"),
    warning: t("warning"),
    info: t("info"),
  };
  const typeHeaderColor = {
    success: "#218838",
    danger: "#c82333",
    warning: "#e0a800",
    info: "#117a8b",
  };

  return (
    <div className="my-toast">
      <div
        className={`toast show text-white bg-${type}`}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        {/* Header */}
        <div
          className={`toast-header text-white `}
          style={{ backgroundColor: typeHeaderColor[type] }}
        >
          <strong className="">{typeHeader[type]}</strong>
          <button
            type="button"
            className="btn-close btn-close-white ms-2 mb-1"
            onClick={() => {
              setVisible(false);
              onClose();
            }}
          ></button>
        </div>

        {/* Body */}
        <div className="toast-body">{message}</div>
      </div>
    </div>
  );
};

export default Toast;
